import { resources } from "@constants/hardcoded-strings";
import { AXNUITheme } from "@iddataweb/idw-common-ui/types";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { ThemingCustomCssValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";
import { PreviewEntityTypes } from "@enums/preview-entity-types";

export const getThemingCustomCssValidationErrors = (
    previewEntityType: PreviewEntityTypes,
    isUsingThemedUI: boolean,
    axnuiTheme: AXNUITheme
): ThemingCustomCssValidationErrors => {
    let count = 0;
    let customCssError = null;
    if (isUsingThemedUI && axnuiTheme.customCss?.useCustomCss && previewEntityType === PreviewEntityTypes.VERIFICATION_SERVICE) {
        if (!axnuiTheme.customCss?.cssContent) {
            count += 1;
            customCssError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
    }

    return {
        customCssError,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.theming.subTabs.customCss.tabName}
            errorCount={count}
        />
    };
};